import { TReadMessagesResponse, fetchReadMessages } from '../../repositories/cian-chat-bot/v1/read-messages';
import { TContext } from '../../types/context';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { ETelemetryEvents } from '../../types/telemetry';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

const DEFAULT_EXCEPTION_MESSAGE = 'Не удалось пометить прочитанными сообщения чатбота';

export async function fetchChatbotReadMessages({ httpApi, logger, telemetry }: TContext): Promise<void> {
  try {
    const { statusCode, response }: TReadMessagesResponse = await fetchReadMessages({
      httpApi,
    });

    if (statusCode !== 200) {
      throw getResponseError({
        response,
        domain: EExceptionDomain.Chatbot,
        defaultMessage: DEFAULT_EXCEPTION_MESSAGE,
        statusCode,
      });
    }
  } catch (error) {
    telemetry.increment(ETelemetryEvents.ChatbotReadMessagesFail);

    const errorToLog = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chatbot,
      message: DEFAULT_EXCEPTION_MESSAGE,
    });

    logger.error(errorToLog, {
      microserviceName: 'cian-chat-bot',
      pathApi: '/v1/read-messages/',
    });
  }
}
